/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import LazyLoadTransition from '../../../components/LazyLoadTransition/LazyLoadTransition';
import './SpeakerCard.scss';

const SpeakerCard = ({ id, name, company, photo, shortDesc, onCardClick, selectedSpeaker }) => {
  const history = useHistory();
  const cardRef = useRef(null);

  const onSpeakerClick = speakerId => {
    if (history.location.pathname === '/speakers') {
      onCardClick(speakerId);
    }
    history.push({
      pathname: `/speakers/${speakerId}`
    });
  };

  useEffect(() => {
    if (
      history.location.pathname === '/speakers' &&
      selectedSpeaker &&
      selectedSpeaker === id &&
      cardRef.current
    ) {
      window.scrollTo(0, cardRef.current.offsetTop + 80);
    }
  });

  return (
    <div
      key={id}
      ref={cardRef}
      className="column is-one-quarter-desktop is-one-third-tablet is-full-mobile"
      id="speaker-card">
      <LazyLoadTransition>
        <div
          className={`card${id.includes('unknown') ? '' : ' featured-speaker'}`}
          onClick={() => onSpeakerClick(id)}>
          <div className="card-content">
            <img
              alt="speaker"
              onError={e => {
                e.target.src = 'imgs/speakers/unknown.png';
              }}
              src={photo || 'imgs/speakers/unknown.png'}
            />
            <p className="speaker-featured-name">{name}</p>
            <p className="speaker-featured-company">{company}</p>
            <p className="speaker-featured-short-desc">{shortDesc}</p>
          </div>
        </div>
      </LazyLoadTransition>
    </div>
  );
};

SpeakerCard.defaultProps = {
  onCardClick: () => {},
  selectedSpeaker: ''
};

SpeakerCard.propTypes = {
  company: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onCardClick: PropTypes.func,
  photo: PropTypes.string.isRequired,
  selectedSpeaker: PropTypes.string,
  shortDesc: PropTypes.string.isRequired
};

export default SpeakerCard;
